import React from "react";
import PreislandingLayout, {
  ProductListContext,
} from "../../layouts/PreislandingLayout";
import ProductsTable from "../../components/products-table/ProductsTable";
import PriceComparisonBanner from "../../components/price-comparison-banner/PriceComparisonBanner";
import SEOComponent from "../../components/Shared/Seo";
import PriceFAQ from "../../components/price-faq/PriceFAQ";

const ZinnpreisPage = () => {
  const { Consumer } = ProductListContext;
  return (
    <PreislandingLayout>
      <SEOComponent page="zinnpreis" />
      <Consumer>
        {value => (
          <ProductsTable
            productList={value.productList}
            categoryId={92}
            name="Zinnpreis"
          />
        )}
      </Consumer>
      <PriceComparisonBanner />
      <PriceFAQ page="zinnpreis" />
    </PreislandingLayout>
  );
};

export default ZinnpreisPage;
